var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "page--reset", attrs: { flat: "" } },
    [
      _c("v-card-title", { staticClass: "headline" }, [
        _vm._v("Reset App Data")
      ]),
      _vm._v(" "),
      _c(
        "v-alert",
        { attrs: { value: true, color: "error", icon: "warning" } },
        [
          _c("p", [
            _c(
              "strong",
              { staticClass: "title", attrs: { "text-color": "error" } },
              [_vm._v("The buttons below should be used with extreme caution!")]
            )
          ]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              "They will result in the permanent deletion of cached room data and unsynced reports, respectively."
            )
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "v-card-text",
        [
          _c(
            "v-layout",
            { staticClass: "text-xs-center", attrs: { row: "" } },
            [
              _c(
                "v-btn",
                {
                  staticClass: "btn__reset_rooms",
                  attrs: { color: "error", disabled: _vm.resetRoomsDisabled },
                  on: {
                    click: function($event) {
                      return _vm.$roomService.reset()
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("delete_forever")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "btn__text" }, [
                    _vm._v("Reset Rooms Cache")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "btn__reset_reports",
                  attrs: { color: "error", disabled: _vm.resetSyncDisabled },
                  on: {
                    click: function($event) {
                      return _vm.$syncService.reset()
                    }
                  }
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v("delete_forever")
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "btn__text" }, [
                    _vm._v("Delete Unsynced Reports")
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6766c9cf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6766c9cf","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reset.vue
// module id = 1ydg
// module chunks = 1